export default __webpack_public_path__ + "paddle_resale_hoverdc7fd5.svg";